import API from '@/views/Fdc/Apis/'
// import { mapGetters } from 'vuex'
import Dayjs from 'dayjs'
import TrendAnalysisChart from '@/components/TrendAnalysisChart/TrendAnalysisChart.vue'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. paging 처리
// FIXME: 2. search condition css 수정
// FIXME: 3. chart click 시 grid row focus 기능

/**
 * Analysis > Parameter Analysis
 * Parameter Analysis
 */
export default {
  name: 'FdcParamAnalysis',
  components: {
    'trend-analysis-chart': TrendAnalysisChart // Trend Analysis Chart component
  },
  // computed: {
  //   ...mapGetters([
  //     'user',
  //     'authed'
  //   ])
  // },
  watch: {
    // historyRowData () {
    //   if (this.historyRowData.length === 0) {
    //     this.noData = true
    //   } else {
    //     this.noData = false
    //   }
    // },
    /**
     * checkedTreeNodes 변화 감지
     * @param {*} value check된 EQP Tree node 배열
     */
    checkedTreeNodes (value) {
      this.paramRowData = []
      this.getMultipleParamList(value)
    },
    /**
     * fromDate 변화 감지
     * fromDate/fromTime, toDate/toTime의 min,max값을 설정합니다.
     */
    fromDate () {
      this.toMinDate = this.fromDate
      let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
      let toDate = Dayjs(this.toDate).format('YYYYMMDD')

      if (fromDate === toDate) {
        this.toMinTime = this.fromTime
        this.fromMaxTime = this.toTime
        if (this.fromTime > this.toTime) {
          this.fromTime = null
        }
      } else {
        this.toMinTime = null
        this.fromMaxTime = null
      }
    },
    /**
     * toDate 변화 감지
     * fromDate/fromTime, toDate/toTime의 min,max값을 설정합니다.
     */
    toDate () {
      this.fromMaxDate = this.toDate
      let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
      let toDate = Dayjs(this.toDate).format('YYYYMMDD')

      if (fromDate === toDate) {
        this.toMinTime = this.fromTime
        this.fromMaxTime = this.toTime
        if (this.toTime < this.fromTime) {
          this.toTime = null
        }
      } else {
        this.toMinTime = null
        this.fromMaxTime = null
      }
    },
    /**
     * fromTime 변화 감지
     * fromTime, toTime의 min,max값을 설정합니다.
     */
    fromTime () {
      if (this.fromDate !== null && this.toDate !== null) {
        let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
        let toDate = Dayjs(this.toDate).format('YYYYMMDD')

        if (fromDate === toDate) {
          this.toMinTime = this.fromTime
        } else {
          this.toMinTime = null
        }
      }
    },
    /**
     * toTime 변화 감지
     * fromTime, toTime의 min,max값을 설정합니다.
     */
    toTime () {
      if (this.fromDate !== null && this.toDate !== null) {
        let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
        let toDate = Dayjs(this.toDate).format('YYYYMMDD')

        if (fromDate === toDate) {
          this.fromMaxTime = this.toTime
        } else {
          this.fromMaxTime = null
        }
      }
    }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.lotCols = [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', flex: 2, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', flex: 2 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', flex: 3 }
      ]
      this.paramCols = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', flex: 1.5, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', flex: 1.5 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 4 },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SPEC'), field: 'specYn', flex: 1 }
      ]
      this.historyCols = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fabId', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), field: 'lotType', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', type: 'dateTimeColumn', width: 130 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', type: 'dateTimeColumn', width: 130 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', type: 'numericColumn', width: 50, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', width: 100 }
      ]
    },
    /**
     * Parameter 목록 조회
     */
    async getMultipleParamList (moduleList) {
      let nodes = moduleList

      let fabList = []
      let eqpIdList = []
      let moduleIdList = []

      nodes.forEach(node => {
        fabList.push(node.detail.fab)
        eqpIdList.push(node.detail.eqpId)
        moduleIdList.push(node.detail.moduleId)
      })

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        moduleId: moduleIdList + '',
        'useYn': 'Y'
      }

      let response = await API.BaseInfo.getEqpsParams(obj)
      this.paramRowData = response
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    async eqpTreeSelected (node) {
      this.selectedTreeNode = node
      if (node.level !== 5) {
        return false
      }

      if (node.detail.moduleId === '') {
        return
      } else {
        this.fab = node.detail.fab
        this.eqpId = node.detail.eqpId
        this.moduleId = node.detail.moduleId
      }

      let params = {
        fab: node.detail.fab,
        eqpId: node.detail.eqpId,
        moduleId: node.detail.moduleId,
        useYn: 'Y'
      }

      try {
        let paramList = await API.BaseInfo.getEqpsParams(params)
        this.paramRowData = [...paramList]
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * EQP Tree Check시 수행하는 method
     * @param {*} checkedNodes check된 tree node 배열
     */
    eqpTreeChecked (checkedNodes) {
      this.checkedTreeNodes = checkedNodes
    },
    /**
     * Search Condition validation
     * @returns {Boolean} validation 성공 여부
     */
    checkSearchCondition () {
      let checkedParamRows = this.$refs.eqpParamGrid.gridApi.getSelectedRows()
      if (checkedParamRows.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PARAMETER')]))
        return false
      }
      if (this.$refs.fromDate.$data.dateSelected === null ||
        this.$refs.fromTime.$data.dateSelected === null ||
        this.$refs.toDate.$data.dateSelected === null ||
        this.$refs.toTime.$data.dateSelected === null
      ) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PERIOD')]))
        return false
      }
      return true
    },
    /**
     * Parameter Analysis data 조회
     */
    getData () {
      if (!this.checkSearchCondition()) {
        return false
      }

      // FIXME: 불필요 항목 주석처리
      // this.$commonUtil.setStoreEqpTree(
      //   this.selectedTreeNode,
      //   this.$refs.fdcEqpTree.treeType
      // )

      this.fabList = []
      this.eqpList = []
      this.moduleList = []
      this.lotList = []

      if (this.nodeArr.length === 0) {
        this.checkedTreeNodes.forEach((node) => {
          this.fabList.push(node.detail.fab)
          this.eqpList.push(node.detail.eqpId)
          this.moduleList.push(node.detail.moduleId)
        })
      } else {
        this.nodeArr.forEach((node) => {
          this.fabList.push(node.detail.fab)
          this.eqpList.push(node.detail.eqpId)
          this.moduleList.push(node.detail.moduleId)
        })
      }

      // 검색에 사용된 searchCondition Setting
      this.makeParameterList()
      this.getChartData('TIME')
      this.getEqpLotHistoryList()
    },
    /**
     * LOT Hitory에서 연동시 검색 조건 설정 (From ~ To)
     * @param {Array} lotList LOT History에서 선택한 row data 배열
     */
    getMinMaxTime (lotList) {
      let minTime = null
      let maxTime = null
      lotList.forEach((lot) => {
        if (minTime === null && maxTime === null) {
          minTime = lot.endDt
          maxTime = lot.endDt
        }

        if (minTime > lot.endDt) {
          minTime = lot.endDt
        }

        if (maxTime < lot.endDt) {
          maxTime = lot.endDt
        }
      })

      this.fromDate = new Date(Dayjs(minTime).format('YYYY-MM-DD HH:mm:ss'))
      this.fromTime = this.fromDate

      this.toDate = new Date(Dayjs(maxTime).format('YYYY-MM-DD HH:mm:ss'))
      this.toTime = this.toDate
    },
    /**
     * Chart data 조회
     * @param {*} orderType chart data order type (TIME/LOT/SUBSTRATE)
     */
    getChartData (orderType) {
      let reqParam = []
      let paramNameList = []
      let reqParamNameList = []

      if (this.nodeArr.length === 0) {
        this.checkedTreeNodes.forEach((node) => {
          reqParam.push({
            fabId: node.detail.fab,
            eqpId: node.detail.eqpId,
            moduleId: node.detail.moduleId
          })
        })
      } else {
        this.nodeArr.forEach((node) => {
          reqParam.push({
            fabId: node.detail.fab,
            eqpId: node.detail.eqpId,
            moduleId: node.detail.moduleId
          })
        })
      }

      for (let paramData of this.searchedParamList) {
        paramNameList.push(paramData.paramName)
        // this.labels.push(checkedData.paramName)
        reqParamNameList.push({
          fab: paramData.fab,
          eqpId: paramData.eqpId,
          moduleId: paramData.moduleId,
          paramName: paramData.paramName
        })
      }

      let lotIdList = []

      if (this.$refs.lotListGrid) {
        for (let checkedData of this.$refs.lotListGrid.gridApi.getSelectedRows()) {
          lotIdList.push(checkedData.lotId)
        }
      }

      if (this.$refs.searchedLotListGrid) {
        for (let checkedData of this.$refs.searchedLotListGrid.gridApi.getSelectedRows()) {
          lotIdList.push(checkedData.lotId)
        }
      }

      let obj = {
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + Dayjs(this.fromTime).format('HHmm') + '00000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + Dayjs(this.toTime).format('HHmm') + '59999',
        reqParam: reqParam,
        orderType: orderType,
        paramName: paramNameList,
        lotId: lotIdList,
        reqParamName: reqParamNameList
      }
      this.trendAnalysisChartObj = obj
      setTimeout(() => {
        this.$refs.trendAnalysisChart.getDataInitial()
      }, 100)
    },
    /**
     * LOT History 조회
     */
    async getEqpLotHistoryList () {
      let fab = null
      let eqpId = null
      let moduleId = null
      let lots = null

      if (this.nodeArr.length === 0) {
        fab = this.fabList
        eqpId = this.eqpList
        moduleId = this.moduleList

        let tempArr = [...this.$refs.searchedLotListGrid.gridApi.getSelectedRows()]
        lots = []
        tempArr.forEach(arr => {
          lots.push(arr.lotId)
        })

        if (lots.length === 0) {
          lots = null
        } else {
          lots = lots + ''
        }
      } else {
        fab = this.fabList
        eqpId = this.eqpList
        moduleId = this.moduleList

        let tempArr = [...this.$refs.lotListGrid.gridApi.getSelectedRows()]
        lots = []
        tempArr.forEach(arr => {
          lots.push(arr.lotId)
        })

        if (lots.length === 0) {
          lots = null
        } else {
          lots = lots + ''
        }
      }

      let params = {
        searchKeyword: '',
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        lotId: lots,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + Dayjs(this.fromTime).format('HHmm') + '00000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + Dayjs(this.toTime).format('HHmm') + '59999',
        page: this.paging.currentPage,
        size: this.paging.size,
        lotSubstrateValue: 'LOT'
      }

      let data = await API.Monitor.getEqpsLots(params)

      this.tempRowData = [...data]
      this.paging.total = data.length
      this.paging.totalPage = Math.floor(data.length / this.paging.size)
      this.paging.currentPage = 0

      this.historyRowData = this.tempRowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)
    },
    /**
     * columns 배열 설정
     * condition에 Lot 또는 Substrate 선택에 따라 columns 배열을 설정합니다.
     */
    // setLotSubstrateGrid () {
    //   if (this.lotSubstrateValue === 'LOT') {
    //     this.historyCols.map(col => {
    //       if (col.binding === 'substId' || col.binding === 'slot') {
    //         col.visible = false
    //       }
    //     })
    //   } else {
    //     this.historyCols.map(col => {
    //       if (col.binding === 'substId' || col.binding === 'slot') {
    //         col.visible = true
    //       }
    //     })
    //   }
    // },
    /**
     * Grid Change Page method
     * @param {*} page current page
     */
    changedPage (page) {
      this.paging.currentPage = page
      this.historyRowData = this.tempRowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)
    },
    /**
     * Export Excel
     * 조회된 data를 Excel 파일로 다운로드 합니다.
     */
    exportCSV () {
      this.$refs.eqpLotHistoryGrid.gridApi.exportDataAsCsv({
        fileName: 'EqpLot_History.csv'
      })
      // this.$refs.eqpLotHistoryGrid.exportExcel('EqpLot_History')
    },
    /**
     * Splitter resize event
     */
    resized () {
      this.$refs.trendAnalysisChart.resized()
    },
    /**
     * LOT List 조회 (Search condition)
     */
    async searchLotListWithKeyword () {
      let keyword = this.lotSearchKeyword

      if (this.checkedTreeNodes.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      }

      let fab = []
      let eqpId = []
      let moduleId = []
      this.checkedTreeNodes.forEach((node) => {
        fab.push(node.detail.fab)
        eqpId.push(node.detail.eqpId)
        moduleId.push(node.detail.moduleId)
      })

      let params = {
        searchKeyword: _.isEmpty(keyword) ? '' : keyword,
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + Dayjs(this.fromTime).format('HHmm') + '00000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + Dayjs(this.toTime).format('HHmm') + '59999',
        lotSubstrateValue: 'LOT'
      }
      let data = await API.Monitor.getEqpsLots(params)
      this.searchedLotList = [...data]
    },
    /**
     * Chart option용 Parameter List 및 Model List 설정
     */
    makeParameterList () {
      let makeParamList = []
      for (let checkedData of this.$refs.eqpParamGrid.gridApi.getSelectedRows()) {
        makeParamList.push({
          fab: checkedData.fab,
          eqpId: checkedData.eqpId,
          moduleId: checkedData.moduleId,
          paramName: checkedData.paramName,
          virtualYn: checkedData.virtualYn,
          specYn: checkedData.specYn
        })
      }
      makeParamList.sort((a, b) => {
        if (a.paramName < b.paramName) return -1
        if (a.paramName > b.paramName) return 1
        return 0
      })
      makeParamList.sort((a, b) => {
        if (a.moduleId < b.moduleId) return -1
        if (a.moduleId > b.moduleId) return 1
        return 0
      })
      makeParamList.sort((a, b) => {
        if (a.eqpId < b.eqpId) return -1
        if (a.eqpId > b.eqpId) return 1
        return 0
      })
      makeParamList.sort((a, b) => {
        if (a.fab < b.fab) return -1
        if (a.fab > b.fab) return 1
        return 0
      })

      let specList = makeParamList.filter(item => item.specYn === 'Y')
      this.searchedParamList = makeParamList
      this.specParamList = specList
    },
    /**
     * EQP Tree 조회 (설정된 기간으로)
     */
    searchEqpEvenTree () {
      let fromDate = Dayjs(this.fromDate).format('YYYYMMDD') + Dayjs(this.fromTime).format('HHmm') + '00000'
      let toDate = Dayjs(this.toDate).format('YYYYMMDD') + Dayjs(this.toTime).format('HHmm') + '59999'
      this.$refs.fdcEqpTree.getEventTree(fromDate, toDate)
    },
    /**
     * chart click event
     * @param {*} e event
     * @param {*} x x data
     * @param {*} points points
     */
    chartOnClick (e, x, points) {
      // [2020.10.00 brique] - highlight series locked event 추가
      // let g = this.$refs.trendAnalysisChart.$refs.dyGraphs.g
      let grid = this.$refs.eqpLotHistoryGrid
      let tempRowData = this.tempRowData
      let self = this
      let that = this.$refs.trendAnalysisChart
      let chartData = this.$refs.trendAnalysisChart.chartDataList

      // if (g.isSeriesLocked()) {
      //   // g.setAnnotations([])
      //   // g.clearSelection()
      //   BriqueChart.relayout('plotlyChart', { annotations: [] })
      // } else {
      // series selection 고정
      // g.setSelection(g.getSelection(), g.getHighlightSeries(), true)

      // [2020.10.00] grid 시점 연동
      // let series = document.querySelector('#dyGraphs').style.display === 'none' ? e : g.getHighlightSeries()
      let series = e
      let seriesDatas = series.split('-')
      let eqpInfo = points.data.eqpInfo

      let lotId = null
      let stepId = null
      let originalDataList = that.chartOriginalDataList

      if (that.currentChartKind === 'TIME') {
        for (let data of originalDataList) {
          if (data.eqpId === seriesDatas[0] &&
            data.moduleId === seriesDatas[1] &&
            data.paramName === seriesDatas[2]) {
            var da
            var formatDa

            if (that.bindingXType === 'DATE') {
              da = new Date(x)
              formatDa = Dayjs(da).format('YYYY-MM-DD HH:mm:ss')
            } else if (that.bindingXType === 'INDEX') {
              let dataArr = chartData[x]
              da = new Date(dataArr[0])
              formatDa = Dayjs(da).format('YYYY-MM-DD HH:mm:ss')
            }

            if (data.sampleTimes.search(formatDa) !== -1) {
              lotId = data.lotId
              let sampleTimeList = JSON.parse(data.sampleTimes)
              let sampleIndex = sampleTimeList.findIndex(element => element.search(formatDa) !== -1)
              let stepIdList = JSON.parse(data.steps)
              stepId = stepIdList[sampleIndex]
            }
          }
        }
      } else if (that.currentChartKind === 'LOT') {
        x = Dayjs(x).add(9, 'h').unix() + '' + Dayjs(x).format('SSS').valueOf()
        lotId = series
        let currentTime
        let beforeTime = null
        for (let data of originalDataList) {
          if (data.lotId === lotId &&
            data.fabId === eqpInfo.fab &&
            data.eqpId === eqpInfo.eqpId &&
            data.moduleId === eqpInfo.moduleId) {
            let sampleTimeList = JSON.parse(data.sampleTimes)
            let j = 0
            let sampleIdx = null
            for (let sampleTime of sampleTimeList) {
              let strTime = sampleTime.slice(0, 19) + '.' + sampleTime.slice(-3)
              let time = new Date(strTime).getTime()

              currentTime = time
              if (beforeTime === null) {
                beforeTime = time
              }
              if ((currentTime - beforeTime) >= x) {
                sampleIdx = j
                break
              }
              j++
            }
            let stepIdList = JSON.parse(data.steps)
            stepId = stepIdList[sampleIdx]
          }
        }
      } else if (that.currentChartKind === 'SUBSTRATE') {
        x = Dayjs(x).add(9, 'h').unix() + '' + Dayjs(x).format('SSS').valueOf()
        lotId = seriesDatas[0]
        for (let data of originalDataList) {
          if (data.lotId === lotId &&
            data.fabId === eqpInfo.fab &&
            data.eqpId === eqpInfo.eqpId &&
            data.moduleId === eqpInfo.moduleId) {
            let sampleTimeList = JSON.parse(data.sampleTimes)
            let beforeTime = null
            let currentTime
            let j = 0
            let sampleIdx = null
            for (let sampleTime of sampleTimeList) {
              let strTime = sampleTime.slice(0, 19) + '.' + sampleTime.slice(-3)
              let time = new Date(strTime).getTime()

              currentTime = time
              if (beforeTime === null) {
                beforeTime = time
              }

              if ((currentTime - beforeTime) >= x) {
                sampleIdx = j
                break
              }
              j++
            }
            if (that.stepCount === 'ALL') {
              let stepIdList = JSON.parse(data.steps)
              stepId = stepIdList[sampleIdx]
            }
          }
        }
      }

      let rowIdx = null
      for (let i = 0; i < grid.getAllRows().length; i++) {
        if (grid.getAllRows()[i] &&
          grid.getAllRows().fabId === eqpInfo.fab &&
          grid.getAllRows().eqpId === eqpInfo.eqpId &&
          grid.getAllRows().moduleId === eqpInfo.moduleId &&
          grid.getAllRows().lotId === lotId) {
          rowIdx = grid.getAllRows().dataIndex
        }
      }
      if (rowIdx === null) {
        let pageCnt = 1
        for (let i = 0; i < tempRowData.length; i++) {
          if (tempRowData[i].lotId === lotId &&
            tempRowData[i].fabId === eqpInfo.fab &&
            tempRowData[i].eqpId === eqpInfo.eqpId &&
            tempRowData[i].moduleId === eqpInfo.moduleId) {
            rowIdx = i
          }
        }
        pageCnt = Math.floor(rowIdx / 10)
        rowIdx = rowIdx % 10
        self.$refs.eqpLotHistoryGrid.changedPage(pageCnt)
      }

      // step 정보를 annotation으로 표시 (일단 TIME만 지정)
      if (lotId !== null && stepId !== null) {
        // g.setAnnotations([
        //   {
        //     series: series,
        //     x: x,
        //     shortText: stepId,
        //     text: 'Lot ID : ' + lotId
        //   }
        // ])
        BriqueChart.relayout('plotlyChart', {
          annotations: [{
            text: stepId,
            hovertext: 'Lot ID : ' + lotId,
            x: points.x,
            y: points.y,
            bgcolor: 'rgba(255, 255, 255, 0.9)',
            bordercolor: 'black',
            showarrow: true,
            arrowhead: 2
          }]
        })
      }
      // g.setSelection(g.getSelection(), g.getHighlightSeries(), true)

      setTimeout(() => {
        // grid.scrollIntoView(rowIdx, 0)
        // grid.select(rowIdx, 1)
        // grid.focus()
        let select = false
        let index = 0
        grid.gridApi.forEachNode(node => {
          if (!select && rowIdx === index) {
            node.setSelected(true)
            select = true
          }
          index++
        })
      }, 10)
      // }
    }
  },
  mounted () {
    /**
     * LOT History에서 연동 시 적용될 process
     */
    let query = this.$route.query
    let storeLotList = this.$store.getters['lotHistory:selectedList'].lotList
    let storeTreeList = this.$store.getters['lotHistory:selectedList'].treeList

    if (query.pageType === 'selectedLotHistory' && storeLotList !== undefined && storeLotList !== null) {
      let lotList = []
      storeLotList.forEach(item => {
        let lotData = JSON.parse(item)

        let filterList = lotList.filter(row =>
          row.fab === lotData.fab &&
          row.eqpId === lotData.eqpId &&
          row.moduleId === lotData.moduleId &&
          row.lotId === lotData.lotId
        )
        if (!(filterList.length > 0)) {
          lotList.push(lotData)
        }
        // if (!lotList.includes(lotRow)) {
        // }
      })

      this.lotRowData = lotList

      let treeList = []
      if (typeof storeTreeList === 'string') {
        let item = storeTreeList
        let tree = JSON.parse(item)
        treeList.push({
          detail: {
            fab: tree.fab,
            eqpId: tree.eqpId,
            moduleId: tree.moduleId
          }
        })
      } else {
        storeTreeList.forEach(item => {
          let tree = JSON.parse(item)
          treeList.push({
            detail: {
              fab: tree.fab,
              eqpId: tree.eqpId,
              moduleId: tree.moduleId
            }
          })
        })
      }
      this.nodeArr = treeList

      this.getMinMaxTime(this.lotRowData)
      this.getMultipleParamList(this.nodeArr)

      setTimeout(() => {
        this.$refs.lotListGrid.setAllRowsSelected()
        // let datas = this.$refs.lotListGrid.statuses
        // datas.forEach((data) => {
        //   data.checked = true
        // })
      }, 100)
    } else {
      this.$commonUtil.setSelectedLotHistory({})
    }

    this.searchEqpEvenTree()

    // search condition 중 기간 검색 항목 height 고정
    let left = document.getElementById('search-condition')
    let periodHeight = (130 / left.clientHeight) * 100
    this.periodHeightPercent = Math.round(periodHeight * 10000) / 10000.0
  },
  data () {
    const today = new Date()
    return {
      fab: null, // Fab (search condition)
      fabList: [], // Fab 목록 (search condition)
      eqpId: null, // EQP ID (search condition)
      eqpList: [], // EQP ID 목록 (search condition)
      moduleId: null, // Module ID (search condition)
      moduleList: [], // Module ID 목록 (search condition)
      // lotList: [],
      // nodeObj: {},
      nodeArr: [], // EQP Tree node 배열
      paging: {
        // type: ['none', 'load-more', 'pagination'][2],
        size: 30, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      }, // LOT History grid pagination option
      fromDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), // From Date (condition)
      fromMinDate: null, // From Date Min value
      fromMaxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // From Date Max value
      fromTime: new Date(), // From Time (condition)
      fromMinTime: null, // From Time Min value
      fromMaxTime: new Date(), // From Time Max value
      toDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // To Date (condition)
      toMinDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), // To Date Min value
      toMaxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // To Date Max value
      toTime: new Date(), // To Time Max value
      toMinTime: new Date(), // To Time Min value
      toMaxTime: null, // To Time Max value
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      lotCols: [], // LOT List grid column 배열
      paramCols: [], // Parameter List grid column 배열
      // lotCols: [
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: '2*', readOnly: true, centered: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: '2*', readOnly: true, centered: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: '3*', readOnly: true, centered: true }
      // ], // LOT List grid column 배열
      // paramCols: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: '1.5*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: '1.5*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '4*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SPEC'), binding: 'specYn', width: '1*', readOnly: true }
      // ], // Parameter List grid column 배열
      lotRowData: [], // LOT List grid row data
      paramRowData: [], // Parameter List grid row data
      historyCols: [], // LOT History grid column 배열
      // historyCols: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fabId', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), binding: 'lotType', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', width: 150, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_DATE'), binding: 'startDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_DATE'), binding: 'endDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', numeric: true, width: 50, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', width: 100, readOnly: true }
      // ], // LOT History grid column 배열
      tempRowData: [], // LOT History grid row data
      historyRowData: [], // LOT History grid row data
      searchedParamList: [], // 검색된 Parameter 목록 배열
      specParamList: [], // Spec Display 목록 배열 (Detection Model 목록)
      noData: false, // data 없음 여부
      // graphKey: 0,
      collectionViewOptions: {
        sortDescriptions: ['eqpId']
      }, // Parameter List grid collectionView Option
      checkedTreeNodes: [], // check된 EQP Tree node 배열
      lotSearchKeyword: null, // LOT List 검색 조건 (LOT ID)
      searchedLotList: [], // LOT List grid row data
      periodHeightPercent: 15, // splitter height percent option
      trendAnalysisChartObj: null // Trend Analysis Chart component 전달 Objectb
    }
  }
}
